module.exports = __webpack_public_path__ + "static/img/2-3.5d86a1b2.png";